var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarExploreWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 1.5L7.38173 4.1559C7.46898 4.48 7.51263 4.64205 7.59873 4.77453C7.67493 4.89175 7.77488 4.99168 7.89213 5.0679C8.02458 5.154 8.18663 5.19765 8.51073 5.2849L11.1666 6L8.51073 6.7151C8.18663 6.80235 8.02458 6.846 7.89213 6.9321C7.77488 7.0083 7.67493 7.10825 7.59873 7.2255C7.51263 7.35795 7.46898 7.52 7.38173 7.8441L6.66663 10.5L5.95153 7.8441C5.86428 7.52 5.82063 7.35795 5.73453 7.2255C5.65831 7.10825 5.55837 7.0083 5.44115 6.9321C5.30867 6.846 5.14663 6.80235 4.82253 6.7151L2.16663 6L4.82253 5.2849C5.14663 5.19765 5.30867 5.154 5.44115 5.0679C5.55837 4.99168 5.65831 4.89175 5.73453 4.77453C5.82063 4.64205 5.86428 4.48 5.95153 4.1559L6.66663 1.5Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarExploreWhite);
export default __webpack_public_path__ + "static/media/starExploreWhite.0dd7f2e843270542b84d091b389e6de7.svg";
export { ForwardRef as ReactComponent };